






































































































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Contact } from '@contacts/interfaces/contact';
import { v4 as uuidv4 } from 'uuid';
import Avatar from '@shared/components/avatar/avatar.vue';
import EntitySelect from '@shared/components/forms/inputs/entity-select/entity-select.vue';
import { ContactMergeData } from '@contacts/interfaces/contact-merge-data';
import { HideContactMergeFields } from '@contacts/interfaces/hide-contact-merge-fields';
import BcMergeContactSummaryFields from '@contacts/components/merge-contacts/merge-contact-summary-fields.vue';
import BcMergeContactSelectorFields from '@contacts/components/merge-contacts/merge-contact-selector-fields.vue';
import Checkbox from '@shared/components/forms/inputs/checkbox/checkbox.vue';
import ModulesHelper from '@core/services/modules.helper';

@Component({
  name: 'bc-merge-contacts-modal',
  components: {
    BcMergeContactSelectorFields,
    BcMergeContactSummaryFields,
    avatar: Avatar,
    'bc-entity-select': EntitySelect,
    'bc-checkbox': Checkbox,
  },
})
export default class MergeContactsModal extends Vue {
  @Prop({ type: Boolean, default: false }) readonly showModal: boolean;
  @Prop({ type: Number, default: null }) readonly contactId: number;

  modalId: string = uuidv4();
  currentStep: number = 1;
  contactLoaded: boolean = false;
  isMergingContacts: boolean = false;
  mergeConfirmationCheck: boolean = false;
  mergeDone: boolean = false;
  contact: Contact = null;
  contactToMerge: Contact = null;
  selectedContactDataToMerge: ContactMergeData = {
    fullname: null,
    language: null,
    firstname: null,
    lastname: null,
    birthdate: null,
    gender: null,
    street: null,
    street2: null,
    zip: null,
    city: null,
    country: null,
    phone1: null,
    phone2: null,
    phone3: null,
    email1: null,
    email2: null,
  };

  get tenantId() {
    return this.$store.getters['tenant/selectedTenantId'];
  }

  // Modal && Buttons data
  get modalTitle(): string {
    return this.$t('global.merge_contacts_modal_title').toString();
  }
  get closeButtonLabel(): string {
    return this.$t('global.buttons.close').toString();
  }
  get nextStepButtonLabel(): string {
    return this.$t('global.next').toString();
  }
  get previousStepButtonLabel(): string {
    return this.$t('global.previous').toString();
  }
  get confirmButtonLabel(): string {
    return this.$t('global.buttons.confirm').toString();
  }
  get mergeContactsMessageTitle(): string {
    return this.$t('global.merge_contacts_message_title', {
      contact_merge_fullname: this.contactToMergeFullname,
      contact_fullname: this.contactFullname,
    }).toString();
  }

  get mergeContactsSummaryMessageTitle(): string {
    return this.$t('global.merge_contacts_summary_message_title', {
      contact_fullname: this.contactFullname,
    }).toString();
  }

  // Contact data
  get contactFullname(): string {
    return this.contact?.fullname || '';
  }
  get contactEmail() {
    return this.contact?.contact_detail?.email1 || this.contact?.contact_detail?.email2;
  }
  get contactCode() {
    return this.contact?.code;
  }
  get contactType(): string {
    return this.contact?.type_value;
  }
  get contactPictureUrl() {
    return this.contact?.photo_contact?.url;
  }

  // Contact to merge data
  get contactToMergeId(): number {
    return this.contactToMerge?.id;
  }
  get contactToMergeFullname(): string {
    return this.contactToMerge?.fullname || '__________';
  }
  get contactToMergeEmail() {
    return (
      this.contactToMerge?.contact_detail?.email1 ||
      this.contactToMerge?.contact_detail?.email2 ||
      '_________________'
    );
  }
  get contactToMergeCode() {
    return this.contactToMerge?.code || '_____';
  }
  get contactToMergePictureUrl() {
    return this.contactToMerge?.photo_contact?.url;
  }

  // Fields to select contact data to merge
  get hideContactMergeFields(): HideContactMergeFields {
    return {
      hideFullname:
        (!this.contact?.fullname && !this.contactToMerge?.fullname) ||
        this.contact?.fullname === this.contactToMerge?.fullname,
      hideLanguage:
        (!this.contact?.language && !this.contactToMerge?.language) ||
        this.contact?.language === this.contactToMerge?.language,
      hideFirstname:
        (!this.contact?.contact_individual?.firstname &&
          !this.contactToMerge?.contact_individual?.firstname) ||
        this.contact?.contact_individual?.firstname ===
          this.contactToMerge?.contact_individual?.firstname,
      hideLastname:
        (!this.contact?.contact_individual?.lastname &&
          !this.contactToMerge?.contact_individual?.lastname) ||
        this.contact?.contact_individual?.lastname ===
          this.contactToMerge?.contact_individual?.lastname,
      hideBirthdate:
        (!this.contact?.contact_individual?.birthdate &&
          !this.contactToMerge?.contact_individual?.birthdate) ||
        this.contact?.contact_individual?.birthdate ===
          this.contactToMerge?.contact_individual?.birthdate,
      hideGender:
        (!this.contact?.contact_individual?.gender &&
          !this.contactToMerge?.contact_individual?.gender) ||
        this.contact?.contact_individual?.gender ===
          this.contactToMerge?.contact_individual?.gender,
      hideStreet:
        (!this.contact?.contact_detail?.street && !this.contactToMerge?.contact_detail?.street) ||
        this.contact?.contact_detail?.street === this.contactToMerge?.contact_detail?.street,
      hideStreet2:
        (!this.contact?.contact_detail?.street2 && !this.contactToMerge?.contact_detail?.street2) ||
        this.contact?.contact_detail?.street2 === this.contactToMerge?.contact_detail?.street2,
      hideZip:
        (!this.contact?.contact_detail?.zip && !this.contactToMerge?.contact_detail?.zip) ||
        this.contact?.contact_detail?.zip === this.contactToMerge?.contact_detail?.zip,
      hideCity:
        (!this.contact?.contact_detail?.city && !this.contactToMerge?.contact_detail?.city) ||
        this.contact?.contact_detail?.city === this.contactToMerge?.contact_detail?.city,
      hideCountry:
        (!this.contact?.contact_detail?.country && !this.contactToMerge?.contact_detail?.country) ||
        this.contact?.contact_detail?.country === this.contactToMerge?.contact_detail?.country,
      hidePhone1:
        (!this.contact?.contact_detail?.phone1 && !this.contactToMerge?.contact_detail?.phone1) ||
        this.contact?.contact_detail?.phone1 === this.contactToMerge?.contact_detail?.phone1,
      hidePhone2:
        (!this.contact?.contact_detail?.phone2 && !this.contactToMerge?.contact_detail?.phone2) ||
        this.contact?.contact_detail?.phone2 === this.contactToMerge?.contact_detail?.phone2,
      hidePhone3:
        (!this.contact?.contact_detail?.phone3 && !this.contactToMerge?.contact_detail?.phone3) ||
        this.contact?.contact_detail?.phone3 === this.contactToMerge?.contact_detail?.phone3,
      hideEmail1:
        (!this.contact?.contact_detail?.email1 && !this.contactToMerge?.contact_detail?.email1) ||
        this.contact?.contact_detail?.email1 === this.contactToMerge?.contact_detail?.email1,
      hideEmail2:
        (!this.contact?.contact_detail?.email2 && !this.contactToMerge?.contact_detail?.email2) ||
        this.contact?.contact_detail?.email2 === this.contactToMerge?.contact_detail?.email2,
    };
  }

  // Contact list data
  get contactListFieldConfig() {
    return {
      fieldPath: 'contact',
      fieldReadPath: 'contact',
      name: 'contact',
      label: 'global.contacts.contact.label',
      placeholder: 'global.placeholder_select_a_contact_to_merge',
      options: [],
      id: 'selects-merge-contacts__contact-id',
      rules: [],
      selectLabel: 'fullname',
      selectEntity: 'contact',
      selectMultiple: false,
    };
  }
  get contactListFilters() {
    return [
      { filterField: 'type', value: [`${this.contactType}`] },
      { filterField: 'status', value: [`active`] },
      { filterField: 'avoid_contact_id', value: `${this.contactId}` },
    ];
  }

  get merge_contacts_information_message_1_1() {
    return this.$t('global.merge_contacts_information_message_1_1', {
      contact_fullname: this.contactFullname,
    });
  }
  get merge_contacts_information_message_1_2() {
    return this.$t('global.merge_contacts_information_message_1_2', {
      contact_fullname: this.contactFullname,
    });
  }
  get merge_contacts_information_message_2_1() {
    return this.$t('global.merge_contacts_information_message_2_1', {
      contact_fullname: this.contactFullname,
    });
  }
  get merge_contacts_information_message_2_2() {
    return this.$t('global.merge_contacts_information_message_2_2', {
      contact_fullname: this.contactFullname,
    });
  }
  get merge_contacts_watchout_message() {
    return this.$t('global.merge_contacts_watchout_message', {
      contact_merge_fullname: this.contactToMergeFullname,
    });
  }
  get merge_contacts_access_control_badge_message() {
    return this.$t('global.merge_contacts_access_control_badge_message', {
      contact_merge_fullname: this.contactToMergeFullname,
    });
  }

  // Methods
  closeModal() {
    this.$emit('close-modal');
  }
  previousStep() {
    this.currentStep = this.currentStep - 1;
    this.mergeConfirmationCheck = false;
  }
  nextStep() {
    if (this.currentStep === 1) {
      this.setDefaultContactDataToMerge();
    }
    this.currentStep = this.currentStep + 1;
  }
  resetCurrentStep() {
    this.currentStep = 1;
  }
  get isAccessControlModuleActivated(): boolean {
    return this.$modulesService.hasModuleActivated(ModulesHelper.ACCESS_CONTROL_MODULE_NAME);
  }
  confirmMerge() {
    this.isMergingContacts = true;
    const basePath = this.$bpcApiRouteHelper.getEntityPath('contact');
    const sessionCode = this.getSessionCode();
    this.listenToWebsocketMergeContactsChannel(sessionCode);
    this.$bpcApi
      .post(basePath + '/merge-contacts', {
        contactId: this.contactId,
        contactToMergeId: this.contactToMergeId,
        dataToMerge: this.selectedContactDataToMerge,
        sessionCode: sessionCode,
      })
      .subscribe(
        () => {
          console.log('Request to merge contacts sent');
        },
        () => {
          this.$bpcEcho.leaveMergeContactsChannel(sessionCode);
          this.isMergingContacts = false;
          this.$bpcMessage.showErrorMessage({
            text: 'global.actions.error_requesting_contacts_merge',
          });
        },
      );
  }
  getSessionCode(): string {
    return `merge-contacts-${this.tenantId}-${uuidv4()}`;
  }
  listenToWebsocketMergeContactsChannel(sessionCode: string): void {
    this.$bpcEcho
      .listenMergeContactsChannel(sessionCode)
      .listen('.BPC\\Core\\Events\\ContactsMerged', () => {
        this.$bpcEcho.leaveMergeContactsChannel(sessionCode);
        this.$bpcMessage.showSuccessMessage({
          text: 'global.actions.contacts_merged',
        });
        this.isMergingContacts = false;
        this.mergeDone = true;
        this.$emit('contacts-merged');
      })
      .listen('.BPC\\Core\\Events\\ErrorMergingContacts', () => {
        this.$bpcEcho.leaveMergeContactsChannel(sessionCode);
        this.$bpcMessage.showErrorMessage({
          text: 'global.actions.contacts_not_merged',
        });
        this.isMergingContacts = false;
        this.$emit('error-merging-contacts');
      });
  }
  async getSelectedContact() {
    const baseUrl = this.$bpcApiRouteHelper.getEntityPath('contact');
    const result = await this.$bpcApi
      .get(`${baseUrl}/${this.contactId}`, { params: {} })
      .toPromise();
    this.contact = result.data;
    this.contactLoaded = true;
    // Set as default the contact data in order to merge
    this.setDefaultContactDataToMerge();
  }
  setDefaultContactDataToMerge(): void {
    this.selectedContactDataToMerge.fullname = this.contact?.fullname;
    this.selectedContactDataToMerge.language = this.contact?.language;
    this.selectedContactDataToMerge.firstname = this.contact?.contact_individual?.firstname;
    this.selectedContactDataToMerge.lastname = this.contact?.contact_individual?.lastname;
    this.selectedContactDataToMerge.birthdate = this.contact?.contact_individual?.birthdate;
    this.selectedContactDataToMerge.gender = this.contact?.contact_individual?.gender;
    this.selectedContactDataToMerge.street = this.contact?.contact_detail?.street;
    this.selectedContactDataToMerge.street2 = this.contact?.contact_detail?.street2;
    this.selectedContactDataToMerge.zip = this.contact?.contact_detail?.zip;
    this.selectedContactDataToMerge.city = this.contact?.contact_detail?.city;
    this.selectedContactDataToMerge.country = this.contact?.contact_detail?.country;
    this.selectedContactDataToMerge.phone1 = this.contact?.contact_detail?.phone1;
    this.selectedContactDataToMerge.phone2 = this.contact?.contact_detail?.phone2;
    this.selectedContactDataToMerge.phone3 = this.contact?.contact_detail?.phone3;
    this.selectedContactDataToMerge.email1 = this.contact?.contact_detail?.email1;
    this.selectedContactDataToMerge.email2 = this.contact?.contact_detail?.email2;
  }

  onDataToMergeChanged($value: ContactMergeData) {
    this.selectedContactDataToMerge = { ...$value };
  }

  mounted() {
    this.getSelectedContact();
  }
}
